type Feature = {
  icon: string
  title: string
  description: string
}

const FEATURES: Feature[] = [
  {
    icon: 'ti ti-id-badge-2',
    title: 'Full-service student ID',
    description: 'We create every student ID for you — photo, details, and guardian number — issued as a tap-to-identify RFID card that doubles as their official school ID.',
  },
  {
    icon: 'ti ti-clock-hour-4',
    title: 'Real-time attendance',
    description: 'Entry and exit are time-stamped the moment a card is tapped — no manual roll call.',
  },
  {
    icon: 'ti ti-message-2',
    title: 'SMS parent alerts',
    description: 'Parents and guardians get an SMS the instant their child arrives on or leaves campus.',
  },
  {
    icon: 'ti ti-file-export',
    title: 'Exportable reports',
    description: 'Download attendance records for any student, class, or date range for review and audits.',
  },
  {
    icon: 'ti ti-shield-check',
    title: 'Security & accountability',
    description: 'A verified, tamper-resistant log of who is on campus strengthens day-to-day accountability.',
  },
]

// #features — core capabilities as INSPINIA feature cards.
export const FeaturesSection = () => {
  return (
    <section className="section-custom pb-5" id="features">
      <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <span className="text-muted rounded-3 d-inline-block">Why Gatekeeper</span>
            <h2 className="mt-3 fw-bold mb-3">
              Everything a campus needs to <mark className="fst-italic">verify and inform</mark>
            </h2>
            <p className="text-muted mb-5">A single tap captures identity, logs attendance, and notifies the parent.</p>
          </div>
        </div>

        <div className="row g-4 justify-content-center">
          {FEATURES.map((feature) => (
            <div className="col-md-6 col-xl" key={feature.title}>
              <div className="card border-0 p-2 card-h-100 h-100">
                <div className="card-body">
                  <div className="avatar-xl mb-3">
                    <span className="avatar-title text-bg-primary rounded-circle fs-22">
                      <i className={feature.icon}></i>
                    </span>
                  </div>
                  <h4 className="mb-2">{feature.title}</h4>
                  <p className="text-muted mb-0">{feature.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
